/* eslint-disable */
import { CROWN_FILLED_16 } from "@sznds/icons";
import createSDSIcon from "./icon";

interface AvatarOptions extends Partial<HTMLSpanElement> {
	src: string | HTMLElement;
	premium: boolean;
}

export default class Avatar {
	_container: HTMLSpanElement;
	_img: HTMLElement;
	_premium: HTMLSpanElement;

	constructor({
		className = "",
		src,
		premium = false,
		...props
	}: Partial<AvatarOptions>) {
		this._img = typeof src === "string" ? Mapy.Util.node("img", { src, crossOrigin: "anonymous" }) as HTMLElement : src;
		this._container = Mapy.Util.node("span", {
			className: `ui-avatar ${className}`,
			...props,
		}) as HTMLSpanElement;
		this._img && this._container.appendChild(this._img);
		this._premium = Mapy.Util.node("span", { className: `ui-avatar__premium ${premium ? "" : "hidden"}` }) as HTMLSpanElement;
		this._premium.appendChild(createSDSIcon({
			symbol: CROWN_FILLED_16,
		}));
		this._container.appendChild(this._premium);
	}

	get node() {
		return this._container;
	}

	set src(src: string | HTMLElement) {
		const img = typeof src === "string" ? Mapy.Util.node("img", { src, crossOrigin: "anonymous" }) as HTMLImageElement : src;
		if (this._img) {
			this._img.parentNode.replaceChild(img, this._img);
		} else {
			img && this._premium.before(img);
		}
		this._img = img;
	}

	set premium(premium: boolean) {
		this._premium.classList.toggle("visible", premium);
	}
}
